module.exports = __webpack_public_path__ + "img/writing_EN.615410be.png";